export const RecaptchaMixin = {
  methods: {
    async executeRecaptcha() {
      //Only proceed to execute the recaptcha once the document is ready and hence the recaptcha library has been loaded
      await new Promise(function(resolve) {
        if (document.readyState !== 'complete') {
          document.addEventListener('readystatechange', e => {
            if (e.target.readyState === 'complete') {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
      grecaptcha.execute()
      
      //Once the captcha has been executed, let's wait for our event to be triggered before we retrieve the response
      let response = await new Promise(function (resolve) {
        document.addEventListener("recaptchaCompleted", (e) => {
          const response = grecaptcha.getResponse()
          resolve(response)
        });
      })
      grecaptcha.reset()
      return response
    }
  }
}